<template>
	<div v-if="!isDetailPage || currentPackageIsDetail">
		<div
			class="u-1/1 u-border--top u-text-align--center"
			@click="showOverview()"
			v-if="isDetailPage && currentPackageIsDetail"
		>
			<button class="c-comparison-list__collapse-button-inner u-bg-color-brand--cta">
				<span class="c-link c-filter-section__sub-heading u-white-space--nowrap"
					>&lt; Terug naar het overzicht</span
				>
			</button>
		</div>
		<a :id="`package-details-${resultItem.SerialId}`"></a>
		<div
			class="c-comparison-list__item c-comparison-list__item--result"
			:class="{
				'c-comparison-list__item--retention': resultItem.IsRetention || resultItem.IsCurrentSupplier,
				'c-comparison-list__item--detailed mb+': viewstate.showingDetails,
				mb: !viewstate.showingDetails,
			}"
			ref="detailWrapper"
		>
			<span
				v-if="resultItem.IsRetention || resultItem.IsCurrentSupplier"
				class="u-bg-color-brand--cta u-text-color-white u-position--absolute u-zindex--1 zeta u-weight--bold ph-"
				>Huidige&nbsp;leverancier</span
			>
			<div
				ref="baseDataElement"
				class="c-comparison-list__item--base-data u-bg-color-white ph palm-ph- u-position--relative pt palm-pv-"
			>
				<div>
					<div class="default-mb palm-mb- pb-- palm-pb-- u-border--bottom">
						<div class="layout layout--small u-position--relative">
							<div class="layout__item u-2/24-default u-2/24-lap u-4/24-palm" v-if="resultItem.Position">
								<span class="c-comparison-list__counter lap-epsilon">{{ resultItem.Position }}</span>
							</div>
							<div
								class="asdasd layout__item u-3/24-default u-6/24-portable pr- u-text-align--center u-portable-text-align--left c-comparison-list__provider-logo-wrapper"
							>
								<img
									:src="resultItem.SupplierLogo"
									:alt="resultItem.SupplierName"
									class="c-comparison-list__provider-logo"
								/>
							</div>
							<div
								class="layout__item u-15/24-default u-portable-visuallyhidden"
								:class="{
									'u-11/24-default': !resultItem.Position,
								}"
							>
								<div class="zeta">
									<a
										v-if="resultItem.SupplierUrlName"
										@click="togglePackageDetails()"
										class="u-text-decoration--underline-hover u-text-color-black"
										>{{ resultItem.Name }}</a
									>
									<div>
										<TagList :tags="getTags()"></TagList>
									</div>
								</div>
							</div>

							<div
								class="layout__item u-text-align--right pb- pl0"
								:class="{
									' u-8/24-lap  u-4/24-desk u-14/24-palm': resultItem.Position,
									' u-10/24-lap  u-4/24-desk u-18/24-palm': !resultItem.Position,
								}"
							>
								<template v-if="resultItem.TotalExpensesYearNet">
									<div
										class="c-spec c-spec--amount delta u-font-weight--bold lap-epsilon"
										v-tooltip="resultItem.TotalExpensesYear.ToolTip"
									>
										&euro;
										<span class="delta" v-html="priceMain" />
										<span class="c-spec__decimals">,{{ priceDecimals }}</span>
									</div>
									<span class="u-weight--normal u-white-space--nowrap mb--">
										<span class="u-palm-visuallyhidden">Totaal</span>
										{{ priceText }}
									</span>
									<div
										class="u-bg-color-white pl c-comparison-list__notetext hide-on-sticky u-white-space--nowrap u-display--block"
									>
										<span class="u-text-color-status--green zeta">
											{{ resultItem.ActionTariff }}
										</span>
									</div>
								</template>
							</div>
							<div class="layout__item u-1/1-portable u-desk-visuallyhidden">
								<div class="zeta">
									<a
										@click="togglePackageDetails()"
										class="u-text-decoration--underline-hover u-text-color-black"
									>
										{{ resultItem.Name }}
										<TagList :tags="resultItem.Tags"></TagList>
									</a>
								</div>
							</div>
						</div>
					</div>
					<transition name="fade">
						<price-details
							class="u-portable-visuallyhidden"
							v-if="showPriceDetail && resultItem.ComparisonTabs"
							:tariffs="resultItem.ComparisonTabs.ComparisonTabPrice.TariffTable"
						></price-details>
					</transition>
					<usp-registration-row :resultItem="resultItem"></usp-registration-row>
				</div>
			</div>
			<div
				class="layout layout--bottom layout--flush u-bg-color-white pt- palm-pt0 u-default-visuallyhidden"
				v-if="!(showPriceDetail && resultItem.ComparisonTabs) && !isDetailPage"
			>
				<div class="layout__item u-1/2 pb-">
					<a
						v-if="resultItem.SupplierUrlName"
						class="c-link u-text-color-brand--support pl- u-white-space--nowrap"
						@click="togglePackageDetails()"
					>
						Alles over dit pakket&nbsp;&nbsp;
						<img
							src="@/assets/img/icons/arrow-up-blue.svg"
							alt="Sluit het pakket"
							class="c-comparison-list__more-info-button-arrow"
						/>
					</a>
				</div>

				<div class="layout__item u-1/2 pb- pr- u-text-align--right">
					<a
						@click="togglePriceDetails()"
						:class="{ open: showingPriceDetails }"
						class="c-link c-link--arrow c-link--arrow-blue u-text-color-brand--support c-toggle"
						>Prijsdetails</a
					>
				</div>
			</div>
			<div class="c-comparison-list__item--detail u-position--relative">
				<price-details
					class="u-default-visuallyhidden"
					v-if="
						(showPriceDetail && resultItem.ComparisonTabs) ||
						(showingPriceDetails && resultItem.ComparisonTabs)
					"
					:tariffs="resultItem.ComparisonTabs.ComparisonTabPrice.TariffTable"
				></price-details>
				<package-details
					:resultItemSerialId="resultItem.SerialId"
					:result-item-base-data="resultItem"
					:supplierAssessment="resultItem.SupplierAssessment"
					v-on:show-overview-from-detail="showOverview"
				></package-details>
			</div>

			<div
				hidden
				ref="stickyFooter"
				class="c-comparison-list__item--sticky-footer u-bg-color-white palm-ph- palm-ph- pv ph+ palm-pv-"
			>
				<div class="layout layout--small layout--middle u-position--relative">
					<div class="layout__item u-1/3">
						<a
							v-if="resultItem.RegistrationFormLink"
							rel="noopener"
							class="c-button c-button--fullwidth mb0"
							target="_blank"
							@click="showForm(resultItem, 'footer block')"
							>{{ resultItem.RegistrationFormLink.Text }}</a
						>
						<a
							v-if="!resultItem.RegistrationFormLink"
							class="c-button c-button--disabled c-button--fullwidth mb0"
							v-tooltip="
								'Helaas maakt deze leverancier geen gebruik van de mogelijkheid om dit aanbod direct via ons af te laten sluiten. Bekijk vergelijkbare deals en profiteer van onze hulp en gratis overstapservice.'
							"
							target="_blank"
							>Aanmelden</a
						>
					</div>

					<div class="layout__item pr- u-2/3-palm u-1/3 u-text-align--right u-palm-text-align--left">
						<template v-if="resultItem.TotalExpensesYearNet">
							<div
								class="c-spec c-spec--amount delta lap-epsilon u-font-weight--bold"
								v-tooltip="resultItem.TotalExpensesYearNet.ToolTip"
							>
								&euro;
								<span class="delta" v-html="priceMain" />
								<span class="c-spec__decimals">,{{ priceDecimals }}</span>
							</div>
							<h6 class="u-weight--normal u-white-space--nowrap mb--">
								<span class="u-palm-visuallyhidden">Totaal</span>
								{{ priceText }}
							</h6>
							<div
								class="u-bg-color-white pl c-comparison-list__notetext hide-on-sticky u-white-space--nowrap u-display--block"
							>
								<span class="u-text-color-status--green zeta">{{ resultItem.ActionTariff }}</span>
							</div>
							<span
								class="c-tag c-tag--green lap-small u-default-visuallyhidden"
								v-if="resultItem.TotalDiscount && resultItem.TotalDiscount.Value"
								v-tooltip="resultItem.Action"
								v-html="`${resultItem.TotalDiscount.Text} &euro; ${resultItem.TotalDiscount.Value}`"
							></span>
						</template>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import PriceDetails from './packageDetail/PriceDetails';
import UspRegistrationRow from './packageDetail/UspRegistrationRow';
import PackageDetails from './packageDetail/PackageDetails';

import TagList from './TagList';

import { eventHub } from '@/services/eventhub';
export default {
	components: { PriceDetails, UspRegistrationRow, PackageDetails, TagList },
	props: ['resultItem', 'showDetails', 'userInput'],

	methods: {
		togglePriceDetails() {
			this.showingPriceDetails = !this.showingPriceDetails;
		},
		setPriceLabel() {
			let price;
			if (this.showPerMonth) {
				price = this.getPriceMonth();
			} else {
				price = this.getPriceYear();
			}
			this.priceMain = price.price;
			this.priceDecimals = price.decimals;

			if (this.priceDecimals < 10) {
				this.priceDecimals = '0' + this.priceDecimals;
			}
			if (this.showPerMonth) {
				this.priceText =
					this.resultItem.TotalExpensesMonthNet.Text == 'per maand excl. btw'
						? 'p/m ex. btw'
						: this.resultItem.TotalExpensesMonthNet.Text;
			} else {
				this.priceText =
					this.resultItem.TotalExpensesYearNet.Text == 'per jaar excl. btw'
						? 'p/j ex. btw'
						: this.resultItem.TotalExpensesYearNet.Text;
			}
		},
		getPriceMonth() {
			return this.getPrice(this.resultItem.TotalExpensesMonthNet);
		},
		getPriceYear() {
			return this.getPrice(this.resultItem.TotalExpensesYearNet);
		},
		getPrice(priceObject) {
			let priceData = priceObject.Value.split(',')[0];
			let price = priceObject ? parseInt(priceData) : '';
			let decimalsData = priceObject.Value.split(',')[1];
			let decimals = priceObject ? parseInt(decimalsData) : '';
			let text = priceObject ? priceObject.Text : '';
			return {
				price: price,
				decimals: decimals,
				text: text,
			};
		},
		async togglePackageDetails() {
			this.track('Show Package Details', this.resultItem.SupplierUrlName, this.resultItem.UrlName);
			let detailSettings = {
				supplier: this.resultItem.SupplierUrlName,
				package: this.resultItem.UrlName + '-' + this.resultItem.SerialId,
				packageId: this.resultItem.SerialId,
			};
			eventHub.$emit('changed-detail', detailSettings);
			try {
				history.pushState({ view: 'detail', ...detailSettings }, 'Detail');
			} catch (e) {
				console.info('No history available');
			}
		},

		showOverview() {
			this.unbindScrollHandler();
			this.track('Return to overview from detail');
			this.$emit('show-overview');
			let footerElement = this.$refs.stickyFooter;
			footerElement.setAttribute('hidden', 'hidden');
			eventHub.$emit('show-overview');
			try {
				history.pushState({ view: 'overview' }, 'Overzicht');
			} catch (e) {
				console.info('No history available');
			}
		},
		unbindScrollHandler() {
			window.removeEventListener('scroll', this.scrollHandler);
		},
		bindScrollHandler() {
			window.addEventListener('scroll', this.scrollHandler, {
				passive: true,
			});
		},
		scrollHandler() {
			let baseDataElement = this.$refs.baseDataElement;
			if (!baseDataElement) {
				return false;
			}
			let baseDataElementBottom =
				baseDataElement.getClientRects()[0].height + baseDataElement.getClientRects()[0].top;
			let footerElement = this.$refs.stickyFooter;
			if (!this.isDetailPage || !footerElement) {
				return false;
			}
			if (window.scrollY < baseDataElementBottom) {
				footerElement.setAttribute('hidden', 'hidden');
				footerElement.classList.remove('is-stuck');
				return;
			}
			if (window.scrollY <= this.lastScrollPosition) {
				footerElement.removeAttribute('hidden');
				footerElement.classList.add('is-stuck');
			} else {
				footerElement.setAttribute('hidden', 'hidden');
				footerElement.classList.remove('is-stuck');
			}
			this.lastScrollPosition = window.scrollY;
		},
		getTags() {
			let tags = [...this.resultItem.Tags];

			/*
			tags.push({
					Text: '',
					ToolTip: '',
					Type: '',
				});
				*/
			if (this.resultItem.IsSmartMeterOnly) {
				tags.push({
					Text: 'Slimme meter verplicht',
					ToolTip: 'Om dit pakket af te nemen dient u een slimme meter te hebben',
					Type: 'SmartMeterOnly',
				});
			}

			if (this.resultItem.ActionTag && this.resultItem.ActionTag.length > 0) {
				tags.push({
					Text: this.resultItem.ActionTag,
					ToolTip: this.resultItem.ActionTagTooltip,
					Type: 'DiscountTag',
				});
			}
			return tags;
		},
	},
	computed: {
		showPriceDetail: function () {
			return this.userInput.CostDisplayFilter == 'Tarief';
		},
		showPerMonth: function () {
			return this.userInput.CostDisplayFilter == 'PerMaand';
		},
	},

	mounted() {
		if (this.resultItem.PriceDetail) {
			this.togglePackageDetails();
		}
		eventHub.$on('changed-detail', (params) => {
			if (params.packageId && params.packageId === this.resultItem.SerialId) {
				this.bindScrollHandler();
			}
		});

		this.setPriceLabel();
	},

	data() {
		return {
			priceMain: 0,
			priceDecimals: 0,
			showingPriceDetails: false,
			resultItemDetails: {},
			priceText: 'per jaar',
			viewstate: {
				tabShowing: null,
			},
		};
	},
	watch: {
		showPerMonth() {
			this.setPriceLabel();
		},
	},
};
</script>

<style>
.fade-enter-active,
.fade-leave-active {
	transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
	opacity: 0;
}
</style>
